<template>
  <div class="page-container">
    <div class="biaoge">
      <div class="biaoge-search">
        <div class="tabs-wrapper">
          <el-tabs class="tabs-item" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
                v-for="(tab, index) in tabsSearchList"
                :key="index"
                :label="tab.name"
                :name="tab.name"
            >
              <span slot="label" style="font-size: 14px;">
                <img v-if="tab.url" :src="tab.url" alt="加载中..." style="padding-right:5px;height: 10px;width: 10px"/>
                {{ tab.name }}
              </span>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
<!--      <div class="biaoge-fengexian"></div>-->
      <el-row :gutter="16" class="content-row">
        <!-- 主轴系列区域 - 响应式列布局 -->
        <el-col :span="24" :md="24" class="spindle-col" align="center">
          <div class="section-title"></div>
          <div class="spindle-div">
            <div v-for="(item, index) in spindleList" :key="index">
              <div class="spindle-item"  :class="{ 'selected': item.selected }" @click="handleClickSelect(item)">
                <div style="width: 100px;">
                  <img v-if="item.icon" :src="$VUE_APP_BASE_API + item.icon" alt="" class="spindle-img"/>
                  <div class="spindle-title">{{ item.name }}</div>
                </div>
                <div class="spindle-info">
                  <div>{{ item.modelList }}<br/>
                    {{ item.minimumSpeed + `-` + item.maximumSpeed + ` U/min`}}<br/>
                  {{ item.minproPower + `-` + item.maxproPower + ` 千瓦`}}<br/>
                  {{ item.minproTorque + `-` + item.maxproTorque + ` Nm`}}<br/></div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <!-- 产品性能数据区域 - 响应式列布局 -->
        <el-col :span="24" :md="24" class="chart-col" align="center">
          <div>
            <productComparison @point-selection-change="selectedPoint"  :xAxisData="xAxisData" :seriesData="scatterData" :verticalLabel="seriesName" :key="productComparisonKey"></productComparison>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 产品列表标题区域 - 响应式宽度 -->
    <div class="product-list-header">
      <div style="padding-bottom: 10px;font-weight: bold;font-size: 16px;padding-top: 50px;">{{ $t('product.productList') }}</div>
      <div style="height: 0px;border: 1px solid #FFFFFF;opacity: 0.4;"></div>
    </div>

    <!-- 产品列表容器 - 响应式网格 -->
    <div class="info-container">
      <div
        v-for="(product,index) in productList"
        :key="index"
        :class="isOtherTab ? 'product-card-industry' : 'product-card'"
      >
        <template v-if="isOtherTab">
          <div class="product-card-industry-inner" @click="handleDetail(product)">
            <div class="product-card-industry-image">
              <img v-if="product.picture" :src="$VUE_APP_BASE_API + product.picture" :alt="product.model || product.productName">
              <div v-else class="product-card-industry-placeholder"></div>
            </div>
            <div class="product-card-industry-title">{{ product.model || product.productName }}</div>
            <div class="product-card-industry-desc" v-if="product.proInterface">{{ product.proInterface }}</div>
            <div class="product-card-industry-actions">
              <el-button type="primary" size="mini" @click.stop="handleDetail(product)">{{ $t('details') }}</el-button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="info-player">
            <div style="display: flex;justify-content: space-between;height: 40px;line-height: 40px;">
              <div style="color: #fff; font-weight: bold; font-size: 16px;">{{product.model }}</div>
              <div>
                <el-button size="mini" v-if="product.isCompared" type="primary" @click="handleCancel(product.productId,index)" >{{ $t('cancel') }}</el-button>
                <el-button size="mini" v-if="!product.isCompared" @click="handleCompare(product.productId,index)" style="background-color: #151516;color: #fff;height: 28px;">{{ $t('compare') }}</el-button>
              </div>
            </div>
            <div style="text-align: center;height:143px"><img v-if="product.picture" :src="$VUE_APP_BASE_API + product.picture" alt="加载中..." height="143px"></div>
            <div class="product-info">
              <div class="product-info-item">
                <span style="font-weight: bold;color: rgba(255,255,255,0.6)">{{ $t('product.diameter') }}:</span>
                <span style="color: #fff;">{{ product.diameter }}</span>
              </div>
              <div class="product-info-item">
                <span style="font-weight: bold;color: rgba(255,255,255,0.6)">{{ $t('product.maximumSpeed') }}:</span>
                <span style="color: #fff;">{{ product.maximumSpeed }}</span>
              </div>
              <div class="product-info-item">
                <span style="font-weight: bold;color: rgba(255,255,255,0.6)">{{ $t('product.proInterface') }}:</span>
                <span style="color: #fff;">{{ product.proInterface }}</span>
              </div>
              <div class="product-info-item">
                <span style="font-weight: bold;color: rgba(255,255,255,0.6)">{{ $t('product.bearingLubrication') }}:</span>
                <span style="color: #fff;">{{ product.bearingLubrication }}</span>
              </div>
              <div class="product-info-item">
                <span style="font-weight: bold;color: rgba(255,255,255,0.6)">{{ $t('product.proPower') }}:</span>
                <span style="color: #fff;">{{ product.proPower }}</span>
              </div>
              <div class="product-info-item">
                <span style="font-weight: bold;color: rgba(255,255,255,0.6)">{{ $t('product.proTorque') }}:</span>
                <span style="color: #fff;">{{ product.proTorque }}</span>
              </div>
            </div>
            <div style="text-align: center;">
              <el-button type="text" @click="handleDetail(product)">
                <span style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                  <img :src="require('@/assets/img/product_details_icon.png')" alt="细节" style="width: 16px; height: 16px;">
                  {{ $t( 'details') }}
                </span>
              </el-button>
            </div>
          </div>
        </template>
      </div>
    </div>
      <div style="text-align: center"  v-if="comparedList.length > 1" >
<!--        <el-button type="primary" size="mini" @click="handleCompared">比较</el-button>-->
        <productCompared  :products="comparedList" ></productCompared>
      </div>

  </div>
</template>
<script>

import productComparison from "@/components/ECharts/productComparison.vue";
import {getCategoryList, getProductList, listProductField} from "@/api/sysytem/product";
import productCompared from "@/views/productCenter/productCompared/index.vue";

export default {
  name: 'productCenter',
  components: {productComparison,productCompared},
  data() {
    return {
      // 主轴系列数据
      xAxisData: [],
      scatterData: [],
      // 对比数据
      comparedList: [],
      spindleList: [],
      selectedSpindle: '', // 选中的主轴规格
      //tab
      activeName: '',
      tabsSearchList: [],
      // 产品列表数据
      productList: [],
      dynamicColumns : [],
      seriesName: '',
      chartSelectedIds: [],
      productComparisonKey:1,
    }
  },
  computed: {
    isOtherTab() {
      return this.activeName === '其他'
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 初始化数据
    init() {
      this.getProductCategoryList()
      this.getPro()
      this.getCoreProductList()
    },
    getProductCategoryList() {
      // 查询参数
      const query = { showStatus: 1 };
      const pageReq = {};
      getCategoryList(query, pageReq).then(res => {
        this.spindleList = res.data.map(item => {
          return {
            ...item,
            selected: true
          };
        });
        // this.seriesName = targetColumn.fieldName
        this.$nextTick(()=> {
          const queryPro = {productType: 1}
          getProductList(queryPro, pageReq).then(res => {
            const productList = res.data || [];
            // 组装散点图数据（适配 [类型名称, { id: 产品ID, value: 数值 }] 格式）
            this.scatterData = productList.map(product => {
              // 1. 获取 X 轴关联的类型名称（通常对应 proInterface 或其他分类字段）
              const typeName = product.proInterface || '未分类'; // 替换为实际类型名称字段

              // 2. 解析 Y 轴数值（value）
              let yValue = 0;
              try {
                const customizeObj = JSON.parse(product.customize || '{}');
                yValue = Number(customizeObj.zs) || 0; // 替换为实际数值字段
              } catch (e) {
                console.error(`产品${product.productId}解析数值失败：`, e);
              }

              // 3. 按插件要求的格式返回：[类型名称, { id: 产品ID, value: 数值 }]
              return [
                typeName,
                {
                  id: product.productId, // 产品唯一标识
                  value: yValue          // Y轴数值
                }
              ];
            });

            // 生成 X 轴数据（去重后的类型名称）
            this.xAxisData = [...new Set(
                this.scatterData.map(item => item[0]) // 提取所有类型名称并去重
            )];
          });
        })
      });
    },
    getPro() {
      listProductField().then(res => {
        this.dynamicColumns = res.data
        this.tabsSearchList = res.data.map(item => ({
          name: item.fieldName
        }));
        this.seriesName = res.data[0].fieldName
        if (this.tabsSearchList.length > 0) {
          console.log("this.tabsSearchList",this.tabsSearchList)
          this.activeName = this.tabsSearchList[0].name;
        }
      })
    },
    getCoreProductList() {
      // 查询参数
      const query = { productType: 1 };
      const pageReq = {};
      getProductList(query, pageReq).then(res => {
        this.coreProductList = res.data
        console.log("初始化的参数，",res.data)
      },err => {
        console.log(err)
      }).then(res => {
        this.productList = res
      })
    },
    getProductList(data) {
      // 查询参数
      const query = data;
      const pageReq = {page: 0, size: 6};
      getProductList(query, pageReq).then(res => {
        this.productList = res.data
        this.comparedList = this.$options.data().comparedList
        this.productList.forEach(item => {
          // 判断对象是否没有isCompared属性（hasOwnProperty确保不继承原型链属性）
          if (!item.hasOwnProperty('isCompared')) {
            item.isCompared = false; // 自定义默认值
          }
        });
      });
    },
    handleClickSelect(row){
      row.selected = !row.selected
      let selectedSpindles = this.spindleList.filter(item => item.selected);
      let ids = selectedSpindles.map(item => item.id);
      const query = { productType: 1, typeIds: ids }
      getProductList(query).then(res => {
        const productList = res.data || [];

        // 组装散点图数据（适配 [类型名称, { id: 产品ID, value: 数值 }] 格式）
        this.scatterData = productList.map(product => {
          // 1. 获取 X 轴关联的类型名称（通常对应 proInterface 或其他分类字段）
          const typeName = product.proInterface || '未分类'; // 替换为实际类型名称字段

          // 2. 解析 Y 轴数值（value）
          let yValue = 0;
          try {
            const customizeObj = JSON.parse(product.customize || '{}');
            yValue = Number(customizeObj.zs) || 0; // 替换为实际数值字段
          } catch (e) {
            console.error(`产品${product.productId}解析数值失败：`, e);
          }

          // 3. 按插件要求的格式返回：[类型名称, { id: 产品ID, value: 数值 }]
          return [
            typeName,
            {
              id: product.productId, // 产品唯一标识
              value: yValue          // Y轴数值
            }
          ];
        });

        // 生成 X 轴数据（去重后的类型名称）
        this.xAxisData = [...new Set(
            this.scatterData.map(item => item[0]) // 提取所有类型名称并去重
        )];

        this.productComparisonKey ++;
            this.productList = [];

      });
    },
    // 取消选中产品（这里简单示例，可扩展逻辑）
    handleCancel(id,index) {
      this.productList.forEach(item => {
        if(id == item.productId){
          item.isCompared = false;
        }
      })
      this.$nextTick(()=>{
        this.comparedList = this.comparedList.filter(item => {
          return item.productId !== id;
        });
        this.$forceUpdate()
      })
    },
    // 标记产品为待比较
    handleCompare(id,index) {
      this.productList.forEach(item => {
        if(id === item.productId){
          item.isCompared = true;
        }
      })
      this.$nextTick(()=>{
        this.comparedList.push(this.productList[index])
        this.$forceUpdate()
      })
    },
    // 查看产品细节（可跳转详情页等，这里简单打印）
    handleDetail(product) {
      this.$router.push({ path: '/productDetail', query: {id : product.productId} });
    },
    // 切换tab
    handleClick() {
      const targetColumn = this.dynamicColumns.find(
          col => col.fieldName === this.activeName
      );
      console.log('targetColumn',targetColumn)
      this.seriesName = targetColumn.fieldName
      if (targetColumn) {
        console.log(this.coreProductList," this.coreProductList??")
        this.scatterData = this.coreProductList.map(product => {
          const typeName = product.proInterface || '未分类';
          let value = 0;
          // 场景1：数据在 customize 字段的 JSON 中
          if (product.customize) {
            const fieldCode = targetColumn.fieldCode;
            const customizeObj = JSON.parse(product.customize || '{}');
            value = Number(customizeObj[fieldCode]) || 0;
            console.log(customizeObj[fieldCode], "fieldCode??")
            console.log(value,"value!!???")
          }
          return [
            typeName,
            {
              id: product.productId,
              value: value
            }
          ];
        });
        console.log("this.scatterData  Y轴数据",this.scatterData)
      } else {
        this.scatterData = [];
        console.warn(`未找到与标签“${this.activeName}”对应的动态字段`);
      }
    },
    // 点击离散图
    // selectedPoint(list){
    //   console.log("list", list)
    //   let ids = list.allSelected.map(item => item.productId)
    //   console.log("ids", ids)
    //   if(ids.length>0){
    //     this.getProductList({ids:ids})
    //   } else {
    //     this.productList = []
    //   }
    // }
    selectedPoint(list) {
      // 获取当前点击的点的productId（单个点的点击）
      const currentId = list.point?.productId;
      if (!currentId) return; // 非点点击直接返回

      // 判断当前ID是否已在选中数组中
      const isExist = this.chartSelectedIds.includes(currentId);

      if (isExist) {
        // 第二次点击：移除该ID
        this.chartSelectedIds = this.chartSelectedIds.filter(id => id !== currentId);
      } else {
        // 第一次点击：添加该ID
        this.chartSelectedIds.push(currentId);
      }

      console.log("当前选中的IDs：", this.chartSelectedIds);

      // 根据最终选中的ID数组筛选产品列表
      if (this.chartSelectedIds.length > 0) {
        this.getProductList({ ids: this.chartSelectedIds });
      } else {
        // 若没有选中的ID，清空列表（或保留对比列表数据，根据需求调整）
        this.productList = [];
      }
    }
  }
}
</script>
<style scoped>
.tabs-item ::v-deep .el-tabs__item {
  color: #999; 
}

.tabs-item ::v-deep .el-tabs__item.is-active {
  color: #fff;
  border-color: #409eff;
  background-color: rgba(64, 158, 255, 0.1);
  padding: 4px 16px;
  border-radius: 4px;
}

.tabs-item ::v-deep .el-tabs__item:hover:not(.is-active) {
  color: #666;
}
.page-container {
  background-color: #000;
  color: #fff;
  padding: 0 20px; /* 防止边缘内容溢出 */
  box-sizing: border-box;
}

.section-title {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
}

.biaoge-search {
  height: 57px;
  display: flex;
  align-items: center;
}

.tabs-wrapper {
  padding-left: 20px;
  width: 100%; /* 让选项卡自适应宽度 */
}

.el-tabs__nav-wrap {
  background-color: rgba(0,0,0,0);
}

/* 主要内容容器 - 响应式宽度 */
.biaoge {
  width: 100%;
  max-width: 1165px; /* 保持最大宽度 */
  margin: auto;
  min-height: 380px; /* 用最小高度替代固定高度 */
  background: #151516;
  border-radius: 0px;
  color: #000;
  margin-top: 50px;
  box-sizing: border-box;
}

.biaoge-fengexian {
  width: 100%;
  height: 0px;
  border-radius: 0px;
  border: 1px solid #EEEEEE;
}

/* 主轴列表区域 */
.spindle-div {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 15px;
  color: #fff;
  background-color: #151516;
  padding: 70px 25px;
  box-sizing: border-box;
}

.spindle-item {
  width: 100%;
  height: 83px;
  max-width: 240px; /* 保持原有最大宽度 */
  display: flex;
  align-items: center;
  border: solid 1px rgba(255,255,255,0.5);
  padding: 10px;
  box-sizing: border-box;
}

.spindle-img {
  width: 51px;
  height: 34px;
  margin-right: 10px;
}

.spindle-info {
  width: 118px;
  font-size: 12px;
  color: #c0c4cc;
  flex: 1; /* 自适应剩余宽度 */
}

/* 产品信息样式 */
.product-info {
  display: flex;
  flex-wrap: wrap;
  color: #000;
  margin-top: 40px;
}

.product-info-item {
  width: 50%; /* 小屏幕每行显示2个属性 */
  box-sizing: border-box;
  padding: 0 5px;
}

.product-info-item span {
  font-size: 12px;
}

.spindle-title {
  height: 17px;
  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

/* 产品列表标题区域 */
.product-list-header {
  width: 100%;
  max-width: 1165px;
  margin: auto;
  margin-bottom: 8px;
  box-sizing: border-box;
}

/* 产品列表容器 */
.info-container {
  width: 100%;
  max-width: 1165px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  box-sizing: border-box;
}

/* 产品卡片样式 */
.product-card {
  flex: 1;
  min-width: 280px; /* 最小宽度保证显示完整 */
  max-width: calc(25% - 15px); /* 大屏幕每行3个 */
  box-sizing: border-box;
}

.product-card-industry {
  flex: 0 0 360px;
  width: 360px;
  max-width: 360px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #151516;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-sizing: border-box;
}

.product-card-industry + .product-card-industry {
  margin-top: 0;
}

.product-card-industry-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product-card-industry-image {
  width: 100%;
  height: 200px;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.product-card-industry-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.product-card-industry-placeholder {
  width: 100%;
  height: 100%;
  background: #1a1a1a;
}

.product-card-industry:hover .product-card-industry-image img {
  transform: scale(1.05);
}

.product-card-industry-title {
  font-weight: 700;
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
  margin: 20px 0 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 16px;
}

.product-card-industry-desc {
  font-size: 14px;
  color: rgba(255,255,255,0.65);
  text-align: center;
  padding: 0 16px;
  min-height: 20px;
}

.product-card-industry-actions {
  display: flex;
  justify-content: center;
  padding: 16px 0 24px;
}

.info-player {
  width: 100%;
  /*  height: 330px;*/
  background-color: #151516;
  color: #FFF;
  padding: 10px 15px;
  box-sizing: border-box;
}
/* 产品类别选中后的样式 */
.selected {
  border-color: #409eff;
  background-color: rgba(64, 158, 255, 0.1);

  position: relative;
  padding-right: 24px; /* 根据对勾大小调整 */
}
.selected::after {
  content: "✓"; /* Unicode 对勾符号 */
  color: #67c23a; /* 绿色 */
  font-size: 16px; /* 对勾大小 */
  position: absolute;
  right: 8px; /* 右间距 */
  top: 50%;
  transform: translateY(-50%); /* 垂直居中 */
  font-weight: bold;
}

/* 取消按钮样式 */
.el-button--primary.el-button--mini {
  background-color: #006BFF ;
  border-color: #006BFF ;
}

.el-button--primary.el-button--mini:hover {
  background-color: #0056CC ;
  border-color: #0056CC ;
}
/* 响应式适配 - 平板设备 */
@media (max-width: 992px) {
  /* 调整图表区域内边距 */
  .chart-col {
    padding: 10px;
  }
}

/* 响应式适配 - 手机设备 */
@media (max-width: 768px) {
  /* 调整选项卡内边距 */
  .tabs-wrapper {
    padding-left: 10px;
  }
  /* 调整产品信息项宽度 */
  .product-info-item {
    width: 100%; /* 手机每行1个属性 */
  }
  /* 调整主轴信息字体大小 */
  .spindle-info {
    font-size: 14px;
  }
  /* 调整产品列表标题 */
  .product-list-header {
    padding: 30px 10px 10px;
  }
  /* 调整主要内容容器上边距 */
  .biaoge {
    margin-top: 30px;
  }

  .product-card-industry {
    flex: 0 0 100%;
    width: 100%;
    max-width: 100%;
  }
}

/* 响应式适配 - 840px以下设备 */
@media (max-width: 840px) {
  .spindle-div {
    justify-content: center; /* 主轴元素居中 */
    align-items: center; /* 垂直居中 */
  }
}

/* 极小屏幕适配 */
@media (max-width: 480px) {
  .spindle-img {
    width: 40px;
    height: 28px; /* 缩小图片尺寸 */
  }
  .spindle-item {
    padding: 8px 10px; /* 减小内边距 */
  }
  .info-player {
    height: auto; /* 产品卡片高度自适应 */
    min-height: 330px; /* 保持最小高度 */
  }
  .product-info {
    margin-top: 20px; /* 减小产品信息上边距 */
  }
}
</style>